"use strict";
import NavItem  from  '../components/nav-item';
import SubNav   from  '../components/sub-nav';
import Velocity from 'velocity-animate';
import Vue      from  'vue/dist/vue.common.js';
import debounce from 'lodash/debounce';

const Nav = Vue.component('ts-nav', {
  // template: "INLINE"
  components: {
    'ts-nav-item': NavItem,
    'ts-sub-nav': SubNav
  },

  data() {
    return {
      active: -1,
      small: false,
      mobileMenuState: false,
      mobileSubSectionState: false,
      tDurations: 300,
      isActive: false
    };
  },

  mounted() {
    document.addEventListener('click', this.closeAll);
    window.addEventListener('resize', debounce(this.handleResize, 300));
    this.handleResize();
  },

  computed: {
    menuOpen() {
      return this.mobileMenuState;
    },

    // return if the mobile menu is open and the active submenu is 3
    subSectionOpen() {
      return this.mobileSubSectionState;
    },

    mobileMenuActive() {
      let active = true;
      if (!this.small) {
        active = true;
      }
      else {
        active = this.mobileMenuState;
      }
      return active;
    }
  },

  methods: {
    closeAll() {
      this.active = -1;
    },

    handleResize() {
      this.small = window.innerWidth <= 940;
    },

    toggleMenu(payload) {
      this.active = (this.active === payload) ? -1 : payload;
    },

    toggleSubmenu() {
      this.mobileSubSectionState = !this.mobileSubSectionState;
      this.mobileMenuState = false;
    },

    toggleMobileMenu() {
      this.mobileMenuState = !this.mobileMenuState;
      this.mobileSubSectionState = false;
    },

    tEnter(el, done) {
      Velocity(el, 'slideDown', {
        duration: this.tDurations,
        complete: done
      });
    },

    tLeave(el, done) {
      Velocity(el, 'slideUp', {
        duration: this.tDurations,
        complete: done
      });
    },

    tCancelled(el) {
      Velocity(el, 'stop');
    }
  }
});

export default Nav;